import faqData from "../data/faqData";

// Generate the schema from the visible FAQ, so changes to questions,
// thresholds or explanations cannot leave an invisible separate answer.
const textOf = (node) => {
  if (node === null || node === undefined || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(textOf).join(" ");
  return textOf(node.props && node.props.children);
};

const faqStructuredData = Object.values(faqData).map((entry) => ({
  question: entry.title,
  answer: textOf(entry.content).replace(/\s+/g, " ").trim(),
}));

export default faqStructuredData;
